import { createContext, Dispatch, MutableRefObject, ReactNode, SetStateAction, useContext, useRef, useState } from 'react';

import { PedidoProps } from 'pages/compra/carrinho/types';

export type CarrinhoContext = {
    disabledActions: boolean;
    setDisabledActions: Dispatch<SetStateAction<boolean>>;

    openFinishedSuccessModal: boolean;
    setOpenFinishedSuccessModal: Dispatch<SetStateAction<boolean>>;

    openFinishedErrorModal: boolean;
    setOpenFinishedErrorModal: Dispatch<SetStateAction<boolean>>;

    contentFinishedErrorModal: MutableRefObject<ReactNode>;
    labelFinishedSuccessModal: MutableRefObject<string>;

    selectedPedidos: PedidoProps[];
    setSelectedPedidos: Dispatch<SetStateAction<PedidoProps[]>>;

    pedidos: PedidoProps[];
    setPedidos: Dispatch<SetStateAction<PedidoProps[]>>;

    isFinishAllPolling: boolean;
    setIsFinishAllPolling: Dispatch<SetStateAction<boolean>>;
};

type CarrinhoProvider = {
    children?: ReactNode;
};

const CarrinhoContext = createContext<CarrinhoContext>({} as CarrinhoContext);

export function CarrinhoProvider({ children }: CarrinhoProvider) {
    const [disabledActions, setDisabledActions] = useState<boolean>(false);
    const [openFinishedSuccessModal, setOpenFinishedSuccessModal] = useState<boolean>(false);
    const [openFinishedErrorModal, setOpenFinishedErrorModal] = useState<boolean>(false);
    const contentFinishedErrorModal = useRef<ReactNode>(null);
    const labelFinishedSuccessModal = useRef<string>('');
    const [selectedPedidos, setSelectedPedidos] = useState<PedidoProps[]>([]);
    const [pedidos, setPedidos] = useState<PedidoProps[]>([]);
    const [isFinishAllPolling, setIsFinishAllPolling] = useState<boolean>(false);

    return (
        <CarrinhoContext.Provider
            value={{
                disabledActions,
                setDisabledActions,
                openFinishedSuccessModal,
                setOpenFinishedSuccessModal,
                openFinishedErrorModal,
                setOpenFinishedErrorModal,
                contentFinishedErrorModal,
                labelFinishedSuccessModal,
                selectedPedidos,
                setSelectedPedidos,
                pedidos,
                setPedidos,
                isFinishAllPolling,
                setIsFinishAllPolling,
            }}
        >
            {children}
        </CarrinhoContext.Provider>
    );
}

export const useCarrinhoContext = () => useContext(CarrinhoContext);
